<div class="_register-page">

	<div class="_container">

		<img class="_logo" src="./assets/BEEGO_logo.png" />
		<p class="_title" [translate]="'REGISTER.INTRO'"></p>

		<ng-container *ngIf="!isRegistered">
			<form [formGroup]="employeeForm">
				<form-input label="{{ 'EMPLOYEE.FIRSTNAME' | translate }}" [formControl]="employeeForm.get('firstname') | cast"></form-input>
	
				<form-input label="{{ 'EMPLOYEE.LASTNAME' | translate }}" [formControl]="employeeForm.get('lastname') | cast"></form-input>
	
				<form-input label="{{ 'EMPLOYEE.EMAIL' | translate }}" [formControl]="employeeForm.get('email') | cast"></form-input>
	
				<form-input label="{{ 'EMPLOYEE.PHONE' | translate }}" [formControl]="employeeForm.get('telephone') | cast"></form-input>
	
				<form-input label="{{ 'EMPLOYEE.JOB_ROLE' | translate }}" [formControl]="employeeForm.get('jobRole') | cast"></form-input>
			</form>
	
			<div class="_buttons">
				<button class="_button _register-button" (click)="register()"><span [translate]="'REGISTER.REGISTER'" ></span></button>
			</div>
		</ng-container>

		<ng-container *ngIf="isRegistered">
			<div class="_is-registered">
				<ion-icon name="checkmark-circle-outline"></ion-icon>
				<p [translate]="'REGISTER.IS_REGISTERED'"></p>
			</div>
		</ng-container>
		
	</div>

</div>
